var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#E0E0E0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2245_7519)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.1653 11.9999C25.0972 11.9929 25.0285 11.9929 24.9603 11.9999H10.9603C10.8706 12.0013 10.7815 12.0147 10.6953 12.0399L17.9203 19.2349L25.1653 11.9999Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9048 12.6948L18.6248 19.9448C18.4375 20.1311 18.184 20.2356 17.9198 20.2356C17.6557 20.2356 17.4022 20.1311 17.2148 19.9448L9.99984 12.7498C9.97766 12.8313 9.9659 12.9153 9.96484 12.9998V22.9998C9.96484 23.265 10.0702 23.5194 10.2577 23.7069C10.4453 23.8945 10.6996 23.9998 10.9648 23.9998H24.9648C25.2301 23.9998 25.4844 23.8945 25.672 23.7069C25.8595 23.5194 25.9648 23.265 25.9648 22.9998V12.9998C25.9609 12.8957 25.9406 12.7927 25.9048 12.6948ZM11.6498 22.9998H10.9548V22.2848L14.5898 18.6798L15.2948 19.3848L11.6498 22.9998ZM24.9548 22.9998H24.2548L20.6098 19.3848L21.3148 18.6798L24.9498 22.2848L24.9548 22.9998Z",
    fill: "#666666"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2245_7519"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(9 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/MailIcon.226045abc9fbe3405b9ced343ac55119.svg";
export { ForwardRef as ReactComponent };